import { motion } from 'framer-motion';

interface UploadProgressProps {
    totalFiles: number;
    currentFile: number;
    fileName: string;
    status: 'uploading';
}

const Spinner = () => (
    <svg
        className="animate-spin h-5 w-5 text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
    >
        <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="3"
        />
        <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
    </svg>
);

export const UploadProgress = ({ 
    totalFiles, 
    currentFile, 
    fileName, 
}: UploadProgressProps) => {
    const progress = (currentFile / totalFiles) * 100;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="absolute inset-x-0 bottom-6 mx-auto w-full max-w-xl z-50 px-4"
        >
            <div className="bg-background border rounded-lg shadow-lg p-4">
                <div className="flex items-start space-x-4">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center bg-primary/10">
                        <Spinner />
                    </div>
                    <div className="flex-1 space-y-1">
                        <div className="flex items-center justify-between">
                            <p className="text-sm font-medium">Uploading files...</p>
                            <p className="text-sm text-muted-foreground">
                                {currentFile} of {totalFiles}
                            </p>
                        </div>
                        <div className="text-sm text-muted-foreground truncate">
                            Uploading {fileName}
                        </div>
                        <div className="relative h-1.5 w-full bg-muted rounded-full overflow-hidden">
                            <motion.div
                                className="absolute inset-y-0 left-0 bg-primary"
                                initial={{ width: 0 }}
                                animate={{ width: `${progress}%` }}
                                transition={{ duration: 0.3 }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
};
